module.exports = __webpack_public_path__ + "img/ide-scenes.47a32034.svg";